/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/

import { MessageClass } from './messageClass';

export interface AlarmConfig {
    defaultMsgColore: string;
    pendingAlarmMsgClassFilter: Array<number>;
    pendingAlarmStateFilter: Array<number>;
    messageClasses: Array<MessageClass>;
}
